import { ActionIcon, Box, Button, Divider, Grid, Group, Image, NumberInput, Stack, Text, TextInput, rem } from "@mantine/core";
import Modal, { Props as ModalProps } from "./Modal";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { client } from "../../lib/axiosClient";
import FormData from "form-data";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { IconCheck, IconCloudUpload, IconPhoto, IconPlus, IconTrash, IconUpload, IconX } from "@tabler/icons-react";
import { zodResolver } from 'mantine-form-zod-resolver';
import { z } from 'zod';
import { notifications } from "@mantine/notifications";

import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";

const cookies = new Cookies(null, { path: '/' });
type Props = {
    setSelectedData?: (id: string) => void;
    data?: any;
    refetchData?: () => void;
} & ModalProps;


export const UpdateCoupon = (props: Props) => {
    const { t } = useTranslation();
    const schema = z.object({
        name: z.string({required_error: t('modals.updateCoupon.schemaName')}).min(2, { message: 'الاسم يجب ان لا يقل عن حرفين' }),
    });
    const [loading, setLoading] = useState(false);
    const {onSubmit, reset, getInputProps, setValues, insertListItem, removeListItem, values} = useForm({
        initialValues: {
            coupon: "", discountPercentage: 0
        },
        validate: zodResolver(schema),
        validateInputOnBlur: true,
        validateInputOnChange: true
    });

    useEffect(() => {
        if (props.opened && "data" in props && props.data !== null) {
            const coupon = props.data
            setValues({
                coupon: coupon?.coupon,
                discountPercentage: coupon?.discountPercentage
            })
        }
    }, [props.opened, props.data])

    const onSubmitForm = ({coupon, discountPercentage}: any) => {
        setLoading(true)
        
        
        client.put(`/coupons/${props.data._id}`, {
            coupon,
            discountPercentage
        }, {
            headers: {
                'Accept': 'application/json',
                'Authorization': cookies.get('token') || ""
            }
        })
        .then(({data}) => {
            notifications.show({ message: t('modals.updateCoupon.alert01'), color: '#fff' });
            console.log(data);
            setLoading(false)
            typeof props?.refetchData == "function" && props?.refetchData()
            closeModal()
        })
        .catch((error) => {
            notifications.show({ message: t('modals.updateCoupon.alert02'), color: '#fff' });
            console.log(error)
            setLoading(false)
        });
    }
    
    const closeModal = () => {
        reset();
        props.onClose();
        setLoading(false)
    };

    return (
        <Modal
            {...props} onClose={closeModal} loading={loading}
            footer={
                <Box py={16} px={20} bg="slate.0">
                    <Group justify={"flex-end"} gap={"xs"}>
                        <Button color={'gray'} variant="outline" rightSection={<IconX size={15} />} bg="white" onClick={closeModal}>{t('modals.cancelling')}</Button>
                        <Button color={'#323232'} rightSection={<IconCheck size={15} />} type="submit" form="submit_form">{t('modals.confirmation')}</Button>
                    </Group>
                </Box>
            }
        >
            <Box style={{padding: 20}} >
                <form onSubmit={onSubmit(onSubmitForm)} id="submit_form">
                    <Grid gutter={20} justify="center">
                        <Grid.Col span={12} >
                            <TextInput
                                label={t('modals.updateCoupon.label01')}
                                placeholder={t('modals.updateCoupon.placeholder01')}
                                withAsterisk
                                {...getInputProps("coupon")}
                            />
                        </Grid.Col>
                        <Grid.Col span={12} >
                            <NumberInput
                                label={t('modals.updateCoupon.label02')}
                                placeholder={t('modals.updateCoupon.placeholder02')}
                                withAsterisk
                                {...getInputProps("discountPercentage")}
                            />
                        </Grid.Col>
                    </Grid>
                </form>
            </Box>
        </Modal>
    );
};